// Action creators
// Constants
import { ModalType } from "@ms/uno-constants/lib/local/ModalType";
import { MaxPinItemLimit } from "@ms/uno-constants/lib/local/MruConstants";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Returns true when a pin-plan transition is allowed under the global `MaxPinItemLimit` cap.
 * Unpins (`isCurrentlyPinned === true`) and below-cap pins return true. At-cap pins return false;
 * callers are responsible for surfacing the pin-limit modal via {@link showPinLimitReachedModal}.
 */ export const guardPinLimit = (mruStore, isCurrentlyPinned)=>{
    if (isCurrentlyPinned) {
        return true;
    }
    const pinnedCount = mruStore.getPinnedItems().data?.length ?? 0;
    return pinnedCount < MaxPinItemLimit;
};
/**
 * Opens the shared pin-limit-reached info modal. Use after {@link guardPinLimit} returns false.
 */ export const showPinLimitReachedModal = (modalActionCreator)=>{
    modalActionCreator.openModal({
        modalType: ModalType.Info,
        headerText: Strings.Notifications_PinnedPlanLimitExceededTitle,
        message: Strings.Notifications_AddToPinnedError,
        buttonText: Strings.SharedComponents_ButtonNameOK,
        correlationId: undefined
    });
};
